import type { LucideIcon } from "lucide-react-native";
import {
  Search,
  Waves,
  Layers,
  Magnet,
  Stethoscope,
  MoreHorizontal,
  Droplets,
  Zap,
} from "lucide-react-native";

// ── Breast test types ────────────────────────────────────
export type BreastTestType =
  | "mammogram"
  | "breast_ultrasound"
  | "breast_tomosynthesis"
  | "breast_mri"
  | "clinical_breast_exam"
  | "other";

export interface BreastTestOption {
  id: BreastTestType;
  labelKey: string;
  icon: LucideIcon;
}

const TEST_LABEL_KEY = (id: BreastTestType): string =>
  `med_history.medical.disease_history.breast_testing.test_types.${id}`;

export const BREAST_TEST_OPTIONS: BreastTestOption[] = [
  { id: "mammogram", labelKey: TEST_LABEL_KEY("mammogram"), icon: Search },
  {
    id: "breast_ultrasound",
    labelKey: TEST_LABEL_KEY("breast_ultrasound"),
    icon: Waves,
  },
  {
    id: "breast_tomosynthesis",
    labelKey: TEST_LABEL_KEY("breast_tomosynthesis"),
    icon: Layers,
  },
  { id: "breast_mri", labelKey: TEST_LABEL_KEY("breast_mri"), icon: Magnet },
  {
    id: "clinical_breast_exam",
    labelKey: TEST_LABEL_KEY("clinical_breast_exam"),
    icon: Stethoscope,
  },
  { id: "other", labelKey: TEST_LABEL_KEY("other"), icon: MoreHorizontal },
];

export function getBreastTestLabelKey(testType: string): string {
  return (
    BREAST_TEST_OPTIONS.find((o) => o.id === testType)?.labelKey ??
    TEST_LABEL_KEY("other")
  );
}

// ── Breast condition/symptom types ───────────────────────
export type BreastConditionType = "discharge" | "pain" | "other";

export interface BreastConditionOption {
  id: BreastConditionType;
  labelKey: string;
  icon: LucideIcon;
}

const COND_LABEL_KEY = (id: BreastConditionType): string =>
  `med_history.medical.disease_history.breast_conditions.condition_types.${id}`;

export const BREAST_CONDITION_OPTIONS: BreastConditionOption[] = [
  {
    id: "discharge",
    labelKey: COND_LABEL_KEY("discharge"),
    icon: Droplets,
  },
  { id: "pain", labelKey: COND_LABEL_KEY("pain"), icon: Zap },
  { id: "other", labelKey: COND_LABEL_KEY("other"), icon: MoreHorizontal },
];
